import axios from 'axios'
import config from '../config'
import store from '../store'

const urlParser = document.createElement('a')
var jwt = require('jsonwebtoken')

export function domain (url) {
  urlParser.href = url
  return urlParser.hostname
}

export function count (arr) {
  return arr.length
}

export function prettyDate (date) {
  var a = new Date(date)
  return a.toDateString()
}

export function pluralize (time, label) {
  if (time === 1) {
    return time + label
  }

  return time + label + 's'
}

export function checkToken (token) {
  var decoded = jwt.decode(token)
  var tokenExpiry = new Date(decoded.exp * 1000)
  var now = new Date()
  var diffSec = (tokenExpiry.getTime() - now.getTime()) / 1000
  var diffMin = diffSec / 60
  if (diffMin <= config.sessionTimeout / 2 && diffMin > 0) {
    console.log('Sending a refresh token request')
    getToken(token)
  }
  if (diffMin <= 0) {
    logoutuser(token)
  }
  console.log(diffMin)
}

function getToken(token) {
  var url = config.serverURI + '/token/refresh-token'
  axios
  .post(url, { token })
   .then(response => {
     var data = response.data
     if (data.error) {
       var errorName = data.error
       if (errorName) {
         console.log('error')
       } else {
         console.log('error')
       }

       return
     }

  /* Setting user in the state and caching record to the localStorage */
     if (data.token) {
       var token = 'Bearer ' + data.token

       store.state.token = token
       store.state.user = data.user

       if (window.localStorage) {
         window.localStorage.setItem('user', JSON.stringify(data.user))
         window.localStorage.setItem('token', token)
       }
     }
   })
.catch(error => {
  console.log(error)
})
}

function logoutuser (token) {
  var url = config.serverURI + '/token/tokenlogout?token=' + token

  axios.get(url)
      .then(response => {
        console.log('Response:', response)
      })
      .catch(error => {
        // Request failed.
        console.log('error', error.response)
        var data = error.response.data
        console.log(data.message)
      })
}



// WEBPACK FOOTER //
// ./src/filters/index.js